import * as React from 'react';
import * as _ from 'lodash';

import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import { Formatters } from '../../common/formatters';

export const ClientContacts = ({
    appText,
    handleFormInputChange,    
    handleSubmitForm,
    handleSaveChanges,
    handleEditButton,
    numFormChanges,    
    handleSaveButton,
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsSmallWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        colInputXs: 3,
    });

    let inputPropsMedWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        colInputXs: 4,
    });

    let inputPropsLargeWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        colInputXs: 7,
    });

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        // handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    }); 

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        // onChange: (n, v) => { handleFormInputChange(n, v); },
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsFullWidthOwnRow = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        // onChange: (o) => { handleFormInputChange({target: { type: 'virtualized-select' }}, o); }
    });

    const inputPropsRoleCheckbox = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    const inputPropsTextAreaDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 12,
        colInputXs: 12,
    });

    return (      
        <DetailFormCommon.ClientDetailFormSection title={sectionTitle}>
            <div>                               
                <DetailFormCommon.InventoryNoteRow key={`edit-client-contacts-row-contact-add`}>
                    <DetailFormCommon.ClientDetailFormSection title={appText('add-client-contact')}>            
                        <KendoWrappers.KendoVirtualizedSelectInput
                            name="clientContactsAdd.salutation"                                                
                            label={appText('contact-salutation')}
                            labelKey="text"
                            valueKey="value"
                            required={true}
                            value={Formatters.getStr(formData, 'clientContactsAdd.salutation')}
                            options={formData.options.salutationTypes}                        
                            onChange={(o) => { handleFormInputChange({target: { name: 'clientContactsAdd.salutation', type: 'virtualized-select' }}, o); }}
                            {...inputPropsVirtualizedSelect}                        
                        />                
                            
                        <KendoWrappers.KendoTextInputDebounced
                            name="clientContactsAdd.firstName"
                            label={appText('contact-firstname')}
                            placeholder={appText('contact-firstname.placeholder')}
                            value={Formatters.getStr(formData, 'clientContactsAdd.firstName')}                        
                            required={true}
                            {...inputPropsMedWidthTextDebounced}
                        />
                        
                        <KendoWrappers.KendoTextInputDebounced
                            name="clientContactsAdd.lastName"
                            label={appText('contact-lastname')}
                            placeholder={appText('contact-lastname.placeholder')}
                            required={true}
                            value={Formatters.getStr(formData, 'clientContactsAdd.lastName')}
                            {...inputPropsMedWidthTextDebounced}
                        />
                        
                        <KendoWrappers.KendoTextInputDebounced
                            name="clientContactsAdd.title"
                            label={appText('contact-title')}
                            placeholder={appText('contact-title.placeholder')}
                            required={false}
                            value={Formatters.getStr(formData, 'clientContactsAdd.title')}
                            {...inputPropsLargeWidthTextDebounced}
                        />
                        
                        <KendoWrappers.KendoTextInputDebounced
                            name="clientContactsAdd.phone"
                            label={appText('contact-phone')}
                            value={Formatters.getStr(formData, 'clientContactsAdd.phone')}
                            {...inputPropsMedWidthTextDebounced}
                        />
                        
                        <KendoWrappers.KendoTextInputDebounced
                            name="clientContactsAdd.email"
                            label={appText('contact-email')}
                            value={Formatters.getStr(formData, 'clientContactsAdd.email')}
                            {...inputPropsMedWidthTextDebounced}
                        />
                        
                        <KendoWrappers.KendoTextareaDebounced
                            name="clientContactsAdd.notes"
                            rows={4}
                            label={appText('contact-notes')}
                            value={Formatters.getStr(formData, 'clientContactsAdd.notes')}
                            {...inputPropsTextAreaDebounced}
                        />  
                    </DetailFormCommon.ClientDetailFormSection>
                </DetailFormCommon.InventoryNoteRow>
    
                <DetailFormCommon.ClientContacts
                    name="clientContactsDelete"
                    clientContacts={formData.clientContacts}
                    onClickDelete={(e, o) => handleFormInputChange(e, o)}
                    onClickEdit={(e, o) => handleEditButton(e, o)}
                    onClickSave={(e) => handleSaveButton(e)}
                    deleteButtonVisible={true}
                    saveButtonVisible={false}
                />              
            </div>
        </DetailFormCommon.ClientDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/client/detail-form/client-contacts.tsx